import { ITranslations } from './translations.interface'

const privacyPolicyLink = 'https://www.uk.travelski.com/instit-privacy-policy'
const partnersLink = `<a href='${privacyPolicyLink}' target='_blank' rel='noopener'>our partners</a>`

const translations: ITranslations = {
  navbar: {
    greeting: 'Hello',
    confirmed: 'Reservations',
    quotes: 'Saved Searches',
    profile: 'Profile',
    logout: 'Log out',
  },
  loginRegister: {
    login_page_title: 'Customer Account',
    log_in_or_register: 'Log in or register to book',
    login_register: 'Log in / Register',
    email_not_valid: 'Your email address is incorrect',
    user_info_mandatory_field: 'Required field',
    user_info_invalid_phone: 'Invalid format.',
    user_info_invalid_phone_length: 'Invalid format. Phone number must contain {count} numbers.',
    user_info_invalid_phone_length_range: 'Invalid format. Phone number must contain {min} to {max} numbers.',
    user_info_invalid_phone_length_start_zero: 'Invalid format. Phone number must contain {count} numbers and start by 0.',
    new_password_forgot_password: 'Forgotten password',
    new_password_create_new_password: 'Create your new password',
    new_password1: 'New password',
    new_password2: 'Confirm your new password',
    user_info_forgot_password: 'Forgot my password',
    user_info_already_have_account: 'Already have an account?',
    user_info_enter_email: 'Click Send to reset your password',
    user_info_email_sent: 'We have sent a link to reset your password to',
    user_info_new_password: 'Enter your new password',
    send: 'Send',
    validate: 'Validate',
    i_want_to_register: 'Create my account',
    i_want_to_login: 'Log in',
    new_password_succes: 'Your password has been reset successfully',
    login: 'Log in',
    user_info_your_informations: 'Your information',
    contacts_first_name: 'First name',
    contacts_last_name: 'Last name',
    contacts_email: 'Email',
    contacts_other_email: 'Sign in with another email',
    contacts_password1: 'Password',
    contacts_password2: 'Confirm your password',
    contacts_password_format: 'Your password must:',
    contacts_password_format_lenght: 'Contain a minimum of 8 characters',
    contacts_password_format_lowercase: 'Contain at least 1 lowercase character',
    contacts_password_format_uppercase: 'Contain at least 1 uppercase character',
    contacts_password_format_number: 'Contain at least 1 number',
    contacts_password_format_character: 'Contain at least 1 special character (# ; @ ; $ ...)',
    contacts_passwords_dont_match: 'The passwords do not match',
    contacts_email_is_not_valid: 'The email is not valid',
    user_info_to_contact_you: 'To contact you',
    contacts_address: 'Address',
    contacts_city: 'City',
    contacts_country: 'Country',
    contacts_postal_code: 'Postal code',
    contacts_phone_number: 'Phone number',
    contacts_subscribe_newsletter: 'I subscribe to the Travelski.com newsletter and take advantage of promotions, flash sales, and loyalty benefits!',
    contacts_accept_conditions1: 'I have read and accept the',
    contacts_accept_conditions2: 'terms and conditions',
    contacts_accept_conditions3: 'and I acknowledge that there is no right of withdrawal.',
    update_my_details: 'Update my contact details',
    continue_with_these_contacts: 'Continue with these details',
    user_info_create_account: 'Create an account',
    user_info_is_it_first_time: 'Are you travelling with Travelski for the first time?',
    contacts_incorrect_credentials: 'Your credentials are incorrect',
    error_wrong_email: 'The entered email address is invalid. Please check the details and try again.',
    register_call_center_modal_title: 'Need help?',
    register_call_center_modal_message: 'Our call center is available during the following working hours to help you complete your booking.',
    register_call_center_modal_phone: 'Phone',
    register_call_center_modal_opening_hours: 'Call center working hours',
    register_call_center_modal_call_button: 'Call the call center',
    mister: 'Mr.',
    madam: 'Ms.',
    link_expired: 'Your link has expired',
    text_resend_link: 'Your password reset link has expired. Please click the button below to receive a new one.',
    button_resend_link: 'Resend link',
    keepInTouch: {
      title: 'Keep in touch',
      emailDealsLabel: 'Best deals e-mails and personalization',
      emailDealsDesc:
        'Exceptional discounts, price drop, early booking, e-mail open tracking',
      partenairesLabel: 'Partner benefits',
      partenairesDesc: `News and benefits from ${partnersLink} (sent by Travelski).`,
      personalize: 'Detailed personalization',
      personalizeTitle: 'Communication preferences',
      sectionDealsTitle: 'Best deals Travelski',
      sectionDealsIntro:
        'Exceptional discounts, early booking and price drop. You can unsubscribe at any time.',
      sectionPartnersTitle: 'Group partners',
      sectionPartnersIntro: `New products and services from Compagnie des Alpes and Travelski partners, as well as the use of technologies that measure e-mail opens to improve and personalize the communications you receive. All communications will be sent by Travelski, we will keep your data, and they will not be shared with ${partnersLink} such as Futuroscope, Les Arcs, La Plagne…`,
      sectionTrackingTitle: 'Personalization of e-mails',
      sectionTrackingIntro:
        'Measures e-mail opens using tracking pixels to avoid unnecessary follow-up e-mails, improve and personalize the communications you receive, and measure the performance of our campaigns. Possible unsubscription at any time with a single click from any newsletter or your customer account.',
      switchEmail: 'E-mail',
      switchEmailDesc: 'The best channel to receive offers and price alerts',
      switchTracking: 'Open tracking',
      switchTrackingDesc: 'Measures if an email was opened (tracking pixel)',
      switchPartenaires: 'Partners communications (e-mail)',
      switchPartenairesDesc: `All the communications will be sent by Travelski, we keep your data and they will not be shared with ${partnersLink}.`,
      switchSms: 'Text message',
      switchSmsDesc: 'Short reminders and important information',
      save: 'Save',
      back: 'Back',
    },
  },
  reservations: {
    pageTitle: 'My Reservations',
    participant: 'participant | participants',
    until: 'until',
    pastBookings: 'My past stays',
    noBooking: 'No reservation ... for now!',
    timeToChoose: 'Where will you spend your next ski holiday? It’s time to choose!',
    search: 'Start a search',
    reference: 'Booking Reference',
    viewDetails: 'View Details',
    payBalance: 'Pay Balance',
    prestId: 'Accommodation Reference:',
    participantInfo: 'Participant information to be completed',
    summaryTitle: 'Booking Summary',
    missingTravellerInfoWarning: 'Participant information to be completed',
    nextStay: 'My Next Stay',
    eurostarTitle: 'Get your Eurostar tickets',
    eurostarBody:
      'Your train tickets will be available on the Eurostar website once your passenger details have been completed. Sign in with your Eurostar booking reference and last name, then fill in the required information to access your e-tickets.',
    eurostarReference: 'Eurostar reference:',
    eurostarCta: 'Get my Eurostar tickets',
    formula: 'Formula',
    equipment: 'Equipment',
    train: 'Train',
    flight: 'Flight',
    transfer: 'Transfer',
    taxi: 'Taxi',
    bus: 'Bus',
    funicular: 'Funicular',
    serviceHours24: 'Service Hours 24/7',
    transport: 'Train + Transfer',
    luggage: 'Luggage',
    luggageBothWays: 'both ways',
    luggageOutboundOnly: 'outbound only',
    luggageInboundOnly: 'return only',
    outbound: 'Outbound:',
    return: 'Return:',
    class: 'class',
    accommodation: 'Accommodation',
    skipass: 'Skipass',
    skipassShort: 'Short Stay Skipass',
    equipmentShort: 'Short Stay Equipment',
    FeeIncluded: 'Service Fee Included',
    viewQuote: 'View accommodation details',
    helmet: 'Helmet',
    option: 'Options',
    proceedToAvailability: 'Check availability of accommodation',
    total: 'Total',
    reserve: 'Reserve',
    payDeposit: 'Pay deposit',
    reserveActionsDepositHint: 'Continue on the booking site',
    reserveActionsPaymentsSection: 'Payment links due',
    reserveActionsPaymentLinkTitle: 'Payment link',
    paymentLinkTitle: 'Payment link {n}',
    echeanceTitle: 'Scheduled payment {n}',
    echeanceTitleSingle: 'Scheduled payment',
    reserveActionsDueBy: 'due by {date}',
    payPaymentLink: 'Pay {amount}',
    payPaymentLinkWithDate: 'Pay {amount} (by {date})',
    payPaymentLinkInstalment: 'Pay payment link {n} — {amount}',
    payPaymentLinkInstalmentWithDate:
      'Pay payment link {n} — {amount} (by {date})',
    reserveActionsTitle: 'What would you like to do?',
    iresaPendingNotice:
      'Your booking is being transferred to iResa. Some actions may be temporarily unavailable.',
    cancel: 'Cancel',
  },
  documents: {
    title: 'Travel documents',
    'booking-confirmation': 'Booking confirmation',
    'booking-confirmation-available': 'Available',
    'booking-confirmation-flight': 'Booking confirmation',
    'booking-confirmation-flight-available': 'Available',
    'booking-confirmation-train': 'Booking confirmation',
    'booking-confirmation-train-available': 'Available',
    vouchers: 'Travel vouchers',
    'vouchers-available': 'Available 10 days before your stay',
    invoice: 'Final invoice',
    'invoice-available': 'Available after your stay',
    other: 'Other documents',
    'other-available': 'Available',
    insurance: 'Cancellation insurance',
    'insurance-available': 'Available',
    cancellation_insurance_certificate: 'Insurance document',
    'cancellation_insurance_certificate-available': 'Available',
    cancellation_insurance_certificatev2: 'Insurance document',
    'cancellation_insurance_certificatev2-available': 'Available',
    'insurance-skieur': 'Skier Insurance',
    'insurance-skieur-available': 'Available',
    'insurance-annulation': 'Zen Cancellation Insurance',
    'insurance-annulation-cosog': 'Garantie annulation',
    'insurance-annulation-available': 'Available',
    'insurance-annulation-cosog-available': 'Available',
    'flight_tickets': 'Flight tickets',
    'flight_tickets-available': 'Available',
    'flight_tickets_aller': 'Flight tickets (outbound)',
    'flight_tickets_aller-available': 'Available',
    'flight_tickets_retour': 'Flight tickets (return)',
    'flight_tickets_retour-available': 'Available',
    'flight_tickets_change': 'Flight schedule change',
    'flight_tickets_change-available': 'Available',
    'skier_insurance_certificate': 'Skier insurance certificate',
    'skier_insurance_certificate-available': 'Available',
    'altibus_ticket_aller': 'Bus tickets (outbound)',
    'altibus_ticket_aller-available': 'Available',
    'altibus_ticket_retour': 'Bus tickets (inbound)',
    'altibus_ticket_retour-available': 'Available',
    'bensbus_ticket': 'Bus tickets',
    'bensbus_ticket-available': 'Available',
    'bensbus_ticket_aller': 'Bus tickets (outbound)',
    'bensbus_ticket_aller-available': 'Available',
    'bensbus_ticket_retour': 'Bus tickets (inbound)',
    'bensbus_ticket_retour-available': 'Available',
    'tne_eticket_aller': 'Train tickets (outbound)',
    'tne_eticket_aller-available': 'Available',
    'tne_eticket_retour': 'Train tickets (inbound)',
    'tne_eticket_retour-available': 'Available',
    download: 'Download',
    claimTitle: 'To declare a claim and track its progress',
    myInsuredArea: 'My insured area',
    noDocuments: 'No documents available for this booking.',
  },
  
  payments: {
    title: 'Balance Payment',
    flexProduct: 'Flex',
    flexTitle: 'Flexibility',
    flexDescription: 'Cancellation and modification possible according',
    fixedProduct: 'Fixed',
    fixedTitle: 'Best price',
    fixedDescription: 'Non-refundable',
    totalPrice: 'Total Price',
    depositToPay: 'Deposit to be paid',
    leftToPay: 'Balance to be paid',
    totalPaid: 'Deposit (already paid)',
    termsAndConditions: 'terms and conditions',
  },
  travellers: {
    title: 'Participants',
    age: 'Date of Birth',
    firstName: 'Name',
    lastName: 'Surname',
    modifyInformation: 'Edit information',
    modifyNotAllowedMessageBefore: 'To change your travelers details, please contact the customer service at',
    modifyNotAllowedMessageAfter: '(fees could be applied)',
    traveller: 'Participant',
    panelIntro: 'Please enter the names, first names, and ages of each participant to get the best rates.',
    yearsOld: 'years old',
  },
  needHelp: {
    title: 'Need Help?',
    description: 'Got a question? Need advice? Our mountain experts are at your disposal from Savoie.',
    contact: 'Contact us',
  },
  panels: {
    confirm: 'Confirm your selection',
  },
  errorMessages: {
    fieldMandatory: 'Required field',
    atLeastOne18: 'At least one traveller must be 18 years old',
    updateUserInfo: 'Failed to update user information',
    changePassword: 'Password change failed.',
    fetchBookings: 'An error occurred while fetching bookings.',
    fetchLihes: 'An error occurred while fetching lines.',
    fetchProductURL: 'An error occurred while fetching the product URL.',
    fetchServices: 'An error occurred while fetching services.',
    getDocuments: 'An error occurred while fetching documents.',
    login: 'An error occurred while logging in.',
    logout: 'An error occurred while logging out.',
    newPassword: 'An error occurred while setting the new password.',
    refresh: 'An error occurred while refreshing the session.',
    resetPassword: 'An error occurred while resetting the password.',
    search: 'An error occurred while performing the search.',
    register: 'An error occurred while registering.',
    selectBooking: 'An error occurred while selecting the booking.',
    unselectBooking: 'An error occurred while unselecting the booking.',
    updateTraveller: 'An error occurred while updating traveller information.',
    validateTokens: 'An error occurred while validating tokens.',
    handleBookingUILogin: 'An error occurred during Booking UI login.',
    handleCustomerUILogin: 'An error occurred during Customer UI login.',
  },
  successMessages: {
    resetPasswordSuccess: 'Password reset successfully!',
  },
  quotes: {
    pageTitle: 'Saved Searches',
    noQuote: 'No saved searches... for now!',
    timeToChoose: 'Found a stay you like? Save your search and come back to book whenever you want!',
  },
  profile: {
    pageTitle: 'My Profile',
    settingsTitle: 'Account Settings',
    infoTitle: 'Need Help?',
    myInfo: 'My contact details',
    resetPassword: 'Password',
    savePassword: 'Save',
    savingPassword: 'Saving...',
    currentPasswordPlaceholder: 'Current password',
    newPasswordPlaceholder: 'New password',
    confirmPasswordPlaceholder: 'Confirm new password',
    enterYourPassword: 'Enter your current password to set a new one',
    modifyYourPassword: 'Change your password',
    contactUs: 'Contact us',
    FAQ: 'FAQ',
    legal: 'Terms and Conditions',
    communicationPreferences: {
      menuItem: 'Communication preferences',
      title: 'Communication preferences',
      loading: 'Loading…',
      sectionDealsTitle: 'Best deals Travelski',
      sectionDealsIntro:
        'Exceptional discounts, early booking and price drop. You can unsubscribe at any time.',
      sectionPartnersTitle: 'Group partners',
      sectionPartnersIntro: `New products and services from Compagnie des Alpes and Travelski partners, as well as the use of technologies that measure e-mail opens to improve and personalize the communications you receive. All communications will be sent by Travelski, we will keep your data, and they will not be shared with ${partnersLink} such as Futuroscope, Les Arcs, La Plagne…`,
      sectionTrackingTitle: 'Personalization of e-mails',
      sectionTrackingIntro:
        'Measures e-mail opens using tracking pixels to avoid unnecessary follow-up e-mails, improve and personalize the communications you receive, and measure the performance of our campaigns. Possible unsubscription at any time with a single click from any newsletter or your customer account.',
      switchEmail: 'E-mail',
      switchEmailDesc: 'The best channel to receive offers and price alerts',
      switchTracking: 'Open tracking',
      switchTrackingDesc: 'Measures if an email was opened (tracking pixel)',
      switchPartenaires: 'Partners communications (e-mail)',
      switchPartenairesDesc: `All the communications will be sent by Travelski, we keep your data and they will not be shared with ${partnersLink}.`,
      switchSms: 'Text message',
      switchSmsDesc: 'Short reminders and important information',
      save: 'Save',
      back: 'Back',
    },
    editInfoForm: {
      infoTitle: 'Your Information',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      emailChangeInfo: 'Your email address cannot be changed as it is linked to your file and customer account.',
      contactsTitle: 'Contact Information',
      address: 'Address',
      city: 'City',
      postalCode: 'Postal code',
      country: 'Country',
      save: 'Save changes',
      phoneCode: 'Country code',
      phoneNumber: 'Phone number',
    },
  },
  global: {
    pageTitle: "Account"
  }
}

export default translations
